var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share-container flex" }, [
    _vm._m(0),
    _vm._v(" "),
    !_vm.isDarkTheme
      ? _c("div", { staticClass: "flex share-icon" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/share/wx.png"),
              width: "30",
              height: "30",
              alt: ""
            },
            on: {
              click: function($event) {
                return _vm.share(_vm.detail, "wx")
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/share/pyq.png"),
              width: "30",
              height: "30",
              alt: ""
            },
            on: {
              click: function($event) {
                return _vm.share(_vm.detail, "pyq")
              }
            }
          })
        ])
      : _c("div", { staticClass: "flex share-icon" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/share/weixin.png"),
              width: "30",
              height: "30",
              alt: ""
            },
            on: {
              click: function($event) {
                return _vm.share(_vm.detail, "wx")
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("@/assets/share/pengyouquan.png"),
              width: "30",
              height: "30",
              alt: ""
            },
            on: {
              click: function($event) {
                return _vm.share(_vm.detail, "pyq")
              }
            }
          })
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [_c("div", [_vm._v("分享至")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }